import React from 'react';

const TermsForm: React.FC = () => {
  return (
    <main className='px-6 py-12'>
      <div className='mx-auto max-w-[800px]'>
        <h1 className='mb-6 border-b border-gray-300 pb-4 text-2xl font-bold'>
          企業ユーザー利用規約
        </h1>
        <p className='mb-4'>
          DXSTAR for Bank利用規約（以下「本規約」という。）は、「DXSTAR for
          Bank」（以下「本サービス」という。）を利用する全ての方（以下「利用者」という。）に適用されます。
        </p>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>サービス内容</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li>
              本サービスは、株式会社NTTDXパートナー（以下「運営者」という。）が設置、管理及び運営を行い、インターネットを利用して提供するサービスです。利用者向けのサービス内容は以下の通りです。
              <ol className='mb-4 list-none pl-6'>
                <li>
                  (ア)各種掲載コンテンツの閲覧(事例・ソリューション・セミナー開催情報・その他、関連情報
                  等)
                </li>
                <li>(イ)お問い合わせ</li>
              </ol>
            </li>

            <li>
              本サービスへの会員登録が完了した利用者(以下「会員」という。)は上項に加え以下のサービス内容を利用することができます。
              <ol className='mb-4 list-none pl-6'>
                <li>(ア)DX診断（以下「本診断」）の実施</li>
                <li>(イ)本診断の診断結果の閲覧</li>
              </ol>
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>本規約</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>
            利用者が本規約を確認したか否かを問わず、本サービスの利用を開始した時点で、本規約を理解のうえ、同意したものとみなします。
            </li>
            <li className='mb-4'>
            運営者は、本サービスに基づき提供された情報を基に利用者のDX推進をサポートする企業、組織及び団体（以下、構成員とする。）と利用者の間で結される契約等に基づく債務その他一切の責任を負わないものとします。
            </li>
            <li className='mb-4'>
            運営者は事前の通知なしに本規約の内容を変更することがあります。変更した場合、運営者は変更後の本規約を、本サービスを提供するウェブサイト（以下「ウェブサイト」という。）上に公表し、改訂日を更新します。ウェブサイト上に公表した後、利用者が初めてウェブサイトを利用した時点で、変更後の規約に同意したものとみなします。但し、本規約で定める手続きを経て会員として登録された者の同意が必要となるような内容の変更の場合は、会員へ個別に通知又は所定の方法で会員の同意を得るものとします。
            </li>
            <li className='mb-4'>本サービスの一切の権利は運営者が保有します。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>利用者の責任</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>
            利用者は、自己の判断と責任において本サービスを利用することとします。
            </li>
            <li>
            利用者が本サービスの利用、本サービスへの接続又は本規約違反等に関連して生じたクレームや請求又は自己の損害については、自己の責任と費用で解決するものとします。
            </li>
            <li>
            本サービスの利用に際し、利用者は関連する全ての法令に従うこととします。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>会員登録</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>
            利用者のうち、本サービスの会員となることを希望する者（以下「会員希望者」という。）は、本規約を遵守することを同意し、かつ運営者の定める一定の情報（以下「登録事項」という。）を運営者の定める方法で提供することにより、運営者に対し、本サービスの会員登録をすることができます。
            </li>
            <li>
            運営者は、会員希望者が、以下の各号いずれかの事由に該当する場合は、会員登録及び再登録を拒否することがあり、また、その理由について一切開示義務を負いません。
            </li>
              <ul className='mb-4 list-none pl-6'>
                <li>(ア)運営者に提供した登録事項の全部又は一部につき、虚偽、誤記又は記載漏れがあった場合</li>
                <li>(イ)反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力その他これに準ずる者を意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等の反社会的勢力等との何らかの交流もしくは関与を行っていると運営者が判断した場合</li>
                <li>(ウ)過去、運営者との契約に違反した者又はその関係者であると運営者が判断した場合</li>
                <li>(エ)会員登録抹消の措置を受けたことがある場合</li>
                <li>(オ)その他、会員登録を適当でないと運営者が判断した場合</li>
          </ul>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>登録事項の変更</h2>
          <p className='mb-4'>
            会員は、登録事項に変更があった場合、運営者の定める方法により当該変更事項を遅滞なく運営者に通知するものとします。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>ID/パスワードの管理</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>会員は本サービスの利用に関して運営者が発行したID及びパスワードについて、運営者の承諾なく第三者に開示してはならず、かつ第三者に推測されないように管理し、設定しなければなりません。</li>
            <li>会員が前項の規定に反し、運営者の業務遂行に著しい支障を及ぼす又はそのおそれがあると運営者が判断した場合、運営者は発行したパスワードの変更等必要な措置を取る場合があります。</li>
            <li>ID及びパスワード等の管理不十分、使用上の過誤、第三者の使用等による損害の責任は会員が負うものとし、会員の故意又は過失の有無を問わず、運営者は一切の責任を負いません。</li>
            <li>運営者は、前項の規定により必要な措置を取る場合には、あらかじめその旨を会員に通知します。但し、緊急のためやむを得ない場合はこの限りではありません。</li>
            <li>会員のID及びパスワード等を用いて本サービスの利用が開始された場合、その後ログアウトまでの一連の通信はID及びパスワード等が付与された会員自身の正当な権限をもって行われているものとみなし、会員は当該利用にかかる利用料金等を負担するものとします。</li>
            <li>会員は、ID及びパスワード等が盗まれたり、第三者に使用されていることが判明した場合には、直ちにその旨を運営者に通知するとともに、運営者からの指示に従うものとします。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>帯域制御</h2>
          <p className='mb-4'>
            運営者は、本サービスの提供に支障が出ると判断した場合には、運営者所定の通信手段を用いて行う通信について、当該通信に割り当てる帯域を制御することがあります。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>個人情報の取扱い</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>会員情報及び運営者が本サービスの運用にあたり取得した個人情報については、本サービスの『プライバシーポリシー』(URL：https://hokkaido-dx.dxstar.jp/privacy-policy)に基づき、適正に取り扱うものとします。</li>
            <li>本サービスの利用を通して取得した個人情報を、会員の同意なく第三者に提供することはありません。但し、法律に従って開示を要請された場合、犯罪捜査など法律手続きの中で開示を要請された場合、又は公的機関から正当な理由に基づき照会を受けた場合は、これらの情報を開示できるものとします。さらに、第三者に委託を行うに際し、これらの情報を当該第三者に開示することができるものとします。なお、会員登録時の登録事項などの情報についての統計的数値を公表又は第三者に提供する場合があります。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>通信の秘密</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>運営者は、本サービスの提供に伴い取り扱う通信の秘密を電気通信事業法第４条（秘密の保護）に基づき保護し、本サービスの円滑な提供を確保するために必要な範囲でのみ使用又は保存します。   </li>
            <li>運営者は、刑事訴訟法第２１８条(令状による捜索)その他同法の定めに基づく強制の処分が行われた場合には、当該法令及び令状に定める範囲で、特定電気通信役務提供者の損害賠償責任の制限及び発信者情報の開示に関する法律第４条(発信者情報の開示請求等)に基づく開示請求の要件が満たされた場合には、当該開示請求の範囲でそれぞれ前項の守秘義務を負わないものとします。</li>
            <li>運営者は、利用者が本規約で定める禁止事項のいずれかに該当する行為を行い、本サービスの提供を妨害した場合であって、正当防衛又は緊急避難に該当すると認められる場合には、本サービスの円滑な提供を確保するために必要な範囲でのみ利用者の通信の秘密に属する情報の一部を提供することができます。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>本サービスへのリンク</h2>
          <p className='mb-4'>
            リンクの設定に際しては、本サービスへのリンクだとはっきりと分かる表現・記述をしてください。リンクの仕方やページの内容によっては、リンク方法の変更、又はリンクの削除をお願いする場合がありますので、あらかじめご了承ください。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>禁止事項</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>利用者は本サービスを利用するにあたり、以下の行為又は以下の行為に該当すると運営者が判断する行為を行うことを禁止します。</li>
              <ul className='mb-4 list-none pl-6'>
                <li>(ア)法令に違反する行為及び違反する行為を幇助・勧誘・強制・助長する行為</li>
                <li>(イ)他人の知的財産権（特許権、実用新案、著作権、意匠権、商標権等）その他の権利を侵害する行為又は侵害するおそれのある行為</li>
                <li>(ウ)他人の財産、プライバシーもしくは肖像権を侵害する行為、又は侵害するおそれのある行為</li>
                <li>(エ)他人を誹謗中傷し、又はその名誉もしくは信用を毀損する行為</li>
                <li>(オ)わいせつ、もしくは他人に不愉快を与える行為</li>
                <li>(カ)宗教団体・思想団体・無限連鎖講を開設し、又はこれを勧誘する行為</li>
                <li>(キ)特定の個人・団体・民族などを非難・中傷・差別し、又はこれを助長する行為</li>
                <li>(ク)本サービスのコンテンツを改ざんし、又は消去する行為</li>
                <li>(ケ)他人になりすまし本サービスを利用する行為</li>
                <li>(コ)虚偽又は誤解を招くような内容を含む情報等を、掲載等し又は登録する行為</li>
                <li>(サ)本サービスの運営・提供又は他の利用者による本サービスの利用を妨害し、又はそれらに支障をきたす行為</li>
                <li>(シ)運営者の許諾を得ない売買行為、オークション行為、金銭支払やその他の類似行為</li>
                <li>(ス)運営者の許諾を得ない商品やサービスの広告、宣伝を目的としたプロフィール内容の公開、その他スパムメール、チェーンメール等の勧誘を目的とする行為</li>
                <li>(セ)選挙の事前運動、選挙運動又はこれらに類似する行為</li>
                <li>(ソ)その行為が前各号のいずれかに該当することを知りつつ、その行為を助長する形でリンクをはる行為</li>
                <li>(タ)本サービスのサービスを通じて、以下に該当し、又は該当すると運営者の判断する情報を運営者又は第三者に送信、アップロードする行為
                  <ul className='list-disc pl-6'>
                    <li>過度に暴力的又は残虐な表現を含む情報</li>
                    <li>コンピューターウィルスその他の有害なコンピュータープログラムを含む情報</li>
                    <li>反社会的な表現を含む情報</li>
                    <li>チェーンメール等の第三者への情報の拡散を求める情報</li>
                    <li>自殺、自傷行為を助長する表現を含む情報</li>
                    <li>薬物の不適切な利用を助長する表現を含む情報</li>
                  </ul>
                </li>
                <li>(チ)本サービスのネットワーク又はシステム等に過度な負担を及ぼす行為</li>
                <li>(ツ)運営者が提供するソフトウェアその他システムに対するリバースエンジニアリングその他の解析行為</li>
                <li>(テ)本サービスのネットワーク又はシステム等への不正アクセスする行為</li>
                <li>(ト)本サービスの他の利用者又は第三者に不利益、損害、不快感を与える行為</li>
                <li>(ナ)反社会的勢力等に対し利益を供与する行為</li>
                <li>(ニ)地域課題解決に関係のない異性との出会いを目的とした行為</li>
                <li>(ヌ)公序良俗に違反し、又は他人の権利を侵害すると運営者が判断した行為</li>
                <li>(ネ)その他、運営者が不適切であると判断した行為</li>
              </ul>
            <li>運営者は本サービスにおける利用者による情報の送信行為が前項各号のいずれかに該当し、又は該当するおそれがあると運営者が判断した場合には、利用者に事前に通知することなく、当該情報の全部又は一部を削除することができるものとします。運営者は本項に基づき自らが行った措置によって利用者に生じた損害について、一切責任を負いません。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>財産権</h2>
          <p className='mb-4'>
            本サービスの全てのコンテンツの財産権は特に取り決めのない限り、運営者に帰属します。本サービスに投稿された文章・画像・音声などの情報は、本サービスが提供するコンテンツ・メールマガジン・出版物などに転載される場合があります。会員は、投稿したことにより、本項の内容を承諾したものとみなします。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>著作権</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>本サービス上のコンテンツ（文章・画像・音声・その他データ）の著作権は運営者に帰属します。</li>
            <li>会員は、本サービス上の投稿データについて、自らが投稿その他送信することについて適法な権利を有していること及び投稿データが第三者の権利を侵害していないことについて、運営者に対し表明し、保証するものとします。</li>
            <li>会員は、前項に定める投稿データについて、運営者に対し、世界的、非独占的、無償、サブライセンス可能かつ譲渡可能な使用、複製、配布、派生著作物の作成、表示及び実行に関するライセンスを付与します。</li>
            <li>会員は、運営者及び運営者から権利を承継し又は許諾された者に対して著作者人格権を行使しないことに同意するものとします。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>本サービスの利用停止及び会員登録抹消等</h2>
          <p className='mb-4'>
            運営者は、利用者が以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該利用者に対して本サービスの利用を一時的に停止し、又は利用者が会員の場合、会員登録を抹消することができます。
          </p>
          <ul className='mb-4 list-decimal pl-6'>
            <li>本規約のいずれかの条項に違反した場合</li>
            <li>登録事項に虚偽の事実があることが判明した場合</li>
            <li>本規約の「会員登録」第3項に定める会員登録の拒否理由に該当する場合</li>
            <li>その他、運営者が利用者の本サービスの利用継続が適当でないと判断した場合</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>退会</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>会員は、運営者所定の手続の完了により、本サービスの会員を退会し、会員登録を抹消することができます。</li>
            <li>退会後の会員情報の取扱いについては、「個人情報の取扱い」の規定に従うものとします。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>本サービス内容の変更・中止</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>運営者が必要と判断した場合には、利用者への事前の通知なく、いつでも本サービスの内容を変更、停止又は中止することができるものとします。</li>
            <li>本サービスは天災、事変、その他の非常事態が発生し、もしくは発生するおそれがある場合、又は運営者が設置する電気通信設備の障害その他やむを得ない事由が生じた場合、運営者の判断により本サービスの運用の全部又は一部を中断及び中止することができます。</li>
            <li>運営者は理由の如何を問わず、本サービスの提供の中断及び中止によって生じた損害について、一切責任を負いません。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>本サービスの終了</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>運営者は、本サービスの全部又は一部を１か月前の通知により廃止することができるものとします。但し、緊急やむを得ない事由が生じた場合には、運営者の判断により利用者へ通知することなく本サービスを廃止することができるものとします。</li>
            <li>運営者は理由の如何を問わず、本サービスの廃止によって生じた損害について、一切責任を負いません。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>免責事項</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>運営者は、本サービスが利用者の特定の目的に適合すること、期待する機能・商品的価値を有すること、利用者による本サービスの利用が、当該利用者に適用のある法令又は業界団体の内部規則等に適合すること、継続的に利用できること、及び不具合が生じないことについて、いかなる保証も行いません。また、本サービス内の情報内容について、その完全性、正確性、確実性、有用性など、いかなる保証も行いません。</li>
            <li>本サービスの提供、遅滞、変更、中止又は廃止、もしくは運営者の責によらない、提供される情報の流出又は消失などにより発生した損害について、運営者は一切責任を負いません。</li>
            <li>利用者又はその代理人、使用人その他利用者の関係者が本規約に違反する行為をなし、運営者に損害を与えた場合、利用者は運営者に対し、運営者に生じた損害を負担するものとします。</li>
            <li>本サービスの利用者がその利用に関連し、利用者及び第三者に損害を与えた場合は当事者間で紛争を解決するものとします。</li>
            <li>利用者による本サービスの利用に関連又は起因して、他の利用者又は第三者から運営者に対して何らかの請求、訴訟その他の紛争が生じた場合、当該利用者は、運営者に生じた損害を負担するものとします。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>連絡/通知</h2>
          <ol className="mb-4 list-decimal pl-6">
            <li>本サービスに関する問い合わせその他会員からの運営者に対する連絡又は通知及び本規約の変更に関する通知その他運営者から会員に対する連絡又は通知は、会員の登録事項に含まれるメールアドレスへの電子メールによる通知にて行うものとします。但し、会員以外の利用者への通知は、本サービス上での公表により行うものとします。</li>
            <li>運営者が会員の登録事項に含まれるメールアドレスその他の連絡先に連絡又は通知を行った場合、会員は当該連絡又は通知を受領したものとみなします。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>紛争</h2>
          <p className='mb-4'>
            免責事項以外の理由で本サービスに関連して、運営者と本サービス利用者又は第三者の間に紛争が生じた場合、関係者は誠意をもって解決のために努力するものとします。協議による解決ができない場合は、本サービスは日本法に準拠し、東京地方裁判所を専属管轄裁判所とします。
          </p>
        </section>

        <section className='mb-8 text-left'>
          <p className='mb-4'>2025年 3月21日 施行</p>
          <p>以上</p>
        </section>
      </div>
    </main>
  );
};

export default TermsForm;
